import '../../Pages/Skeleton/Skeleton.scss';

const Skeleton = ({type}) => {
    return (
        <div className="skeleton">
            <div className={type}> </div>
        </div>
    )
}

export default function SkeletonProduct() {
   return (
       <div className="skeleton-wrapper">
           <Skeleton type="thumbnail" />
           <Skeleton type="text-lg" />
           <Skeleton type="text-md" />
           <Skeleton type="text-sm" />
           <div className="shimmer-wrapper">
               <div className="shimmer"></div>
           </div>
       </div>
   )
}
// 

 export const Row = () => {
    return (
    <div className="row" style={{width:100+'%'}}>
      <div className="skeleton1"></div>
      <div className="skeleton1"></div>
      <div className="skeleton1"></div>
      <div className="skeleton1"></div>
      <div className="skeleton1"></div>
    </div>
    );
}
  
//export default {SkeletonProduct,Row};
 
  